import * as React from "react";
import { useSelector } from "react-redux";
import {
  clearParameters,
  removeParameter,
  setDateParameters,
  setParameters,
} from "../../redux/global/actions";
import { useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import MultiValueInput from "../../inputs/multiValueInput";
import {
  Grid,
  Stack,
  Typography,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useEffect } from "react";
import "./DataQualitySapOrders.css";
import SearchDateInput from "../../inputs/searchDateInput";
import {
  getDataQualitySapOrders,
  getDataQualitySapOrdersBulk,
} from "../../redux/dynamo_db/actions";
import MultiSelector from "../../inputs/MultiSelector";
import { downloadCSV, downloadJSON } from "../../utils";
import { DataTable, MaterialSymbol } from "@datalake/towercontrol-banner";
import ExportMenu from "../../widgets/ExportMenu";

const DATA_QUALITY_SAP_ORDERS_COLUMNS = [
  { id: "creation_date", label: "Creation Date", nowrap: true },
  { id: "delivery_id", label: "Delivery Id", filter: "text", nowrap: true },
  { id: "part_number", label: "Part Number", filter: "text" },
  { id: "sold_to", label: "Sold To", filter: "text" },
  { id: "status", label: "Status", filter: "select" },
  { id: "order_id", label: "Order ID", filter: "text", nowrap: true },
  { id: "order_line", label: "Order Line", filter: "text" },
  { id: "hub", label: "HUB", filter: "text" },
  { id: "quantity", label: "Quantity", align: "right" },
  { id: "real_quantity", label: "Real Quantity", align: "right" },
  { id: "missing_quantity", label: "Missing quantity", align: "right" },
  {
    id: "ship_confirmation_date",
    label: "Ship confirmation date",
    filter: "text",
    nowrap: true,
  },
];

export default function DataQualitySapOrders() {
  const dispatch = useDispatch();

  const queryParameters = useSelector(
    (state) => state?.parameters?.dataQualitySapOrders,
  );

  const [currentPartNumber, setCurrentPartNumber] = React.useState();
  const [currentSoldTo, setCurrentSoldTo] = React.useState();
  const [currentOrderId, setCurrentOrderId] = React.useState();
  const [currentStatus, setCurrentStatus] = React.useState();

  const [openModal, setOpenModal] = React.useState(false);

  const handleExecuteSearch = () => {
    let queryObject = {};
    if (queryParameters.partNumber) {
      queryObject.part_number = queryParameters.partNumber;
    }
    if (queryParameters.soldTos) {
      queryObject.sold_to = queryParameters.soldTos;
    }
    if (queryParameters.orderIds) {
      queryObject.order_id = queryParameters.orderIds;
    }
    if (queryParameters.status) {
      queryObject.status = queryParameters.status;
    }
    if (queryParameters.creationDateStart && queryParameters.creationDateEnd) {
      queryObject.creation_date_from = queryParameters.creationDateStart;
      queryObject.creation_date_to = queryParameters.creationDateEnd;
    } else {
      setOpenModal(true);
      return;
    }
    dispatch(getDataQualitySapOrders(queryObject));
  };

  const handleExecuteBulkSearch = () => {
    let queryObject = {};
    if (queryParameters.partNumber) {
      queryObject.part_number = queryParameters.partNumber;
    }
    if (queryParameters.soldTos) {
      queryObject.sold_to = queryParameters.soldTos;
    }
    if (queryParameters.orderIds) {
      queryObject.order = queryParameters.orderIds;
    }
    if (queryParameters.status) {
      queryObject.type = queryParameters.status;
    }
    if (queryParameters.creationDateStart && queryParameters.creationDateEnd) {
      queryObject.creation_date_from = queryParameters.creationDateStart;
      queryObject.creation_date_to = queryParameters.creationDateEnd;
    } else {
      setOpenModal(true);
      return;
    }
    queryObject.is_bulk = true;
    dispatch(getDataQualitySapOrdersBulk(queryObject));
  };

  const handleDeletePartNumber = (chipToDelete) => () => {
    dispatch(
      removeParameter({ dataQualitySapOrders: { partNumber: [chipToDelete] } }),
    );
  };
  const handleClearPartNumber = () => {
    dispatch(clearParameters({ dataQualitySapOrders: "partNumber" }));
  };
  const handleDeleteSoldTo = (chipToDelete) => () => {
    dispatch(
      removeParameter({ dataQualitySapOrders: { soldTos: [chipToDelete] } }),
    );
  };
  const handleClearSoldTos = () => {
    dispatch(clearParameters({ dataQualitySapOrders: "soldTos" }));
  };
  const handleDeleteOrderId = (chipToDelete) => () => {
    dispatch(
      removeParameter({ dataQualitySapOrders: { orderIds: [chipToDelete] } }),
    );
  };
  const handleClearOrderIds = () => {
    dispatch(clearParameters({ dataQualitySapOrders: "orderIds" }));
  };
  const handleDeleteStatus = (chipToDelete) => () => {
    dispatch(
      removeParameter({ dataQualitySapOrders: { status: [chipToDelete] } }),
    );
  };
  const handleClearStatus = () => {
    dispatch(clearParameters({ dataQualitySapOrders: "status" }));
  };
  const handleExportDataQualityOrders = (dataQualityOrders, format = "csv") => {
    const fields = [
      { name: "creation_date" },
      { name: "delivery_id" },
      { name: "part_number" },
      { name: "sold_to" },
      { name: "status" },
      { name: "order_id" },
      { name: "order_line" },
      { name: "quantity" },
      { name: "real_quantity" },
      { name: "missing_quantity" },
      { name: "hub" },
      { name: "ship_confirmation_date" },
    ];

    if (format === "csv") {
      downloadCSV(fields, "data_quality_orders_export", ",", dataQualityOrders);
    } else {
      downloadJSON(fields, "data_quality_orders_export", dataQualityOrders);
    }
  };
  const statusValues = ["error", "fixed"];
  const dataqualitysaporders = useSelector((state) => {
    if (state.filteredDataQualitySapOrders) {
      return state.filteredDataQualitySapOrders.map(
        (data_quality_sap_orders) => {
          return {
            data_quality_sap_orders_identifier: data_quality_sap_orders?.SK,
            creation_date: data_quality_sap_orders?.creation_date,
            part_number: data_quality_sap_orders?.part_number,
            sold_to: data_quality_sap_orders?.sold_to,
            status: data_quality_sap_orders?.status,
            order_id: data_quality_sap_orders?.order_id,
            order_line: data_quality_sap_orders?.order_line,
            quantity: data_quality_sap_orders?.quantity,
            real_quantity: data_quality_sap_orders?.real_quantity,
            missing_quantity: data_quality_sap_orders?.missing_quantity,
            hub: data_quality_sap_orders?.hub,
            ship_confirmation_date:
              data_quality_sap_orders?.ship_confirmation_date,
            delivery_id: data_quality_sap_orders?.delivery_id,
          };
        },
      );
    } else return [];
  });
  const [openBulkConfirmation, setOpenBulkConfirmation] = React.useState(false);

  const handleKeydown = (event) => {
    if (event.key == "Enter") {
      event.stopPropagation();
      event.preventDefault();
      setTimeout(() => {
        handleExecuteSearch();
      }, 0);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeydown);
    return () => {
      document.removeEventListener("keydown", handleKeydown);
    };
  }, []);

  return (
    <React.Fragment>
      <Dialog open={openBulkConfirmation} maxWidth="xs" fullWidth>
        <DialogContent>
          <Typography variant="body2">
            This query could take a few minutes, are you sure you want to
            continue?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              handleExecuteBulkSearch();
              setOpenBulkConfirmation(false);
            }}
          >
            Yes
          </Button>

          <Button variant="text" onClick={() => setOpenBulkConfirmation(false)}>
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openModal} maxWidth="xs" fullWidth>
        <DialogContent>
          <Typography variant="body2">
            The Search Date values are mandatory.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={() => setOpenModal(false)}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <MultiValueInput
        setCurrentParam={setCurrentPartNumber}
        setQueryParams={setParameters}
        currentParam={currentPartNumber}
        queryParams={queryParameters?.partNumber}
        handleDelete={handleDeletePartNumber}
        handleClear={handleClearPartNumber}
        label="Part Number"
        family="dataQualitySapOrders"
        type="partNumber"
      />
      <MultiValueInput
        setCurrentParam={setCurrentSoldTo}
        setQueryParams={setParameters}
        currentParam={currentSoldTo}
        queryParams={queryParameters?.soldTos}
        handleDelete={handleDeleteSoldTo}
        handleClear={handleClearSoldTos}
        label="Sold To"
        family="dataQualitySapOrders"
        type="soldTos"
      />
      <MultiValueInput
        setCurrentParam={setCurrentOrderId}
        setQueryParams={setParameters}
        currentParam={currentOrderId}
        queryParams={queryParameters?.orderIds}
        handleDelete={handleDeleteOrderId}
        handleClear={handleClearOrderIds}
        label="Order ID"
        family="dataQualitySapOrders"
        type="orderIds"
      />
      <MultiSelector
        setQueryParams={setParameters}
        queryParams={queryParameters?.status}
        handleDelete={handleDeleteStatus}
        handleClear={handleClearStatus}
        label="Status"
        family="dataQualitySapOrders"
        type="status"
        options={statusValues}
      />
      <Grid>
        <SearchDateInput
          title={"Search Date"}
          setFilterDate={setDateParameters}
          family="dataQualitySapOrders"
          type="creationDateStart"
          type2="creationDateEnd"
        />
      </Grid>
      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        <Button
          variant="contained"
          startIcon={<MaterialSymbol name="search" size="button" />}
          onClick={handleExecuteSearch}
        >
          Search
        </Button>
        {/*<Button variant="outlined" onClick={() => setOpenBulkConfirmation(true)}>Bulk Export</Button>*/}
      </Stack>
      {dataqualitysaporders.length > 0 && (
        <DataTable
          title="DataQualitySapOrders"
          subtitle={`${dataqualitysaporders.length} results`}
          columns={DATA_QUALITY_SAP_ORDERS_COLUMNS}
          rows={dataqualitysaporders}
          getRowId={(row, i) =>
            `${row?.data_quality_sap_orders_identifier}-${i}`
          }
          defaultRowsPerPage={25}
          size="small"
          actions={(rows) => (
            <ExportMenu
              disabled={!rows.length}
              onExport={(format) => handleExportDataQualityOrders(rows, format)}
            />
          )}
          sx={{ mt: 3 }}
        />
      )}
    </React.Fragment>
  );
}
